<template>
  <div class="ui-content dashboard">
    <v-card class="mx-auto normal-card autohg">
      <div class="data-table-section" ref="infoBox">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-footer
          hide-default-header
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, idx) in items" :key="idx">
                <td class="text-left">{{ item.omr_pattern_id ? item.test_id: "N.A." }}</td>
                <td class="text-left">
                  <v-tooltip left content-class="cust-new-tooltip-bottom">
                                    <template v-slot:activator="{ on, attrs }">
                                    <div v-bind="attrs" v-on="on">
                                        {{ item.alt_test_name }}
                                    </div>
                                    </template>
                                    <span>
                                    <b> Target Exam: </b> {{ item.target_name }} <br/>
                                    <b>Test Pattern: </b> {{ item.omr_pattern_id ? OMR_PATTERN[item.omr_pattern_id] : "Custom" }}
                                    </span>
                                </v-tooltip>
                </td>
                <td class="text-left w-10">                    <v-icon 
                  v-if="item.is_online_test"
                        class="eye-icon"
                        >mdi-laptop</v-icon
                      >
                      <img v-else
                src="../../../assets/img/svg/answer.png"
                class="omr-icon"
              />
                      </td>
                <td class="text-left">
                  <div class="date-ui">
                    {{ getFormatedDate(item.scheduled_start) }}
                  </div>
                  <div class="time-ui">
                    {{ getFormatedTime(item.scheduled_start) }}
                  </div>
                </td>
                <td class="text-left">
                   <template v-if="item.is_shared_test">
                    <v-tooltip 
                      left
                      bottom
                      content-class="cust-new-tooltip-bottom open-bottom tooltip-arrow-top"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <div class="date-ui" v-bind="attrs" v-on="on">
                          {{ getFormatedDate(item.scheduled_end) }}
                        </div>
                        <div class="time-ui">
                          {{ getFormatedTime(item.scheduled_end) }}
                        </div>
                      </template>
                     <span class="text-center tool-tip-position">
  <b>OMR Upload Deadline:</b><br>
  <b>{{ item && item.omr_upload_time ? getFormatedDate(item.omr_upload_time) : '' }}</b>
  {{ item && item.omr_upload_time ? getFormatedTime(item.omr_upload_time) : '' }}
</span>

                    </v-tooltip>
                  </template>
                    <template v-else>
                    <div class="date-ui">
                      {{ getFormatedDate(item.scheduled_end) }}
                    </div>
                    <div class="time-ui">
                      {{ getFormatedTime(item.scheduled_end) }}
                    </div>
                  </template>
                  <!-- <div class="date-ui">
                    {{ getFormatedDate(item.scheduled_end) }}
                  </div>
                  <div class="time-ui">
                    {{ getFormatedTime(item.scheduled_end) }}
                  </div> -->
                </td>
                <!-- <td class="text-left">{{ getFormatedDate(item.scheduled_start) }}</td>
                                <td class="text-left">{{ getFormatedDate(item.scheduled_end) }}</td> -->
                <td class="text-center">{{ item.duration }}</td>
                <td class="text-left">{{ item.name }}</td>
                <td
                  class="text-center rescheduletest"
                  v-if="!checkUserType(roleIds.ED) || item.is_omr_pattern"
                >
                  <div class="Schedule" @click="ScheduleTestDialog(item)">
                    Reschedule
                  </div>
                </td>
                <td class="text-center" v-if="category === 'ONGOING' && user.role_id != roleIds.PA && item.is_online_test">
                  <v-tooltip left content-class="cust-tooltip">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        @click="showLiveTrackingDialog(item)"
                        v-on="on"
                        class="eye-icon"
                        >mdi-eye</v-icon
                      >
                    </template>
                    <span>Live Tracking</span>
                  </v-tooltip>
                </td>
                <td class="text-center" v-if="category === 'UPCOMING'">
                    <v-icon
                        @click="deleteScheduleTestPopup(item)"
                        class="eye-icon"
                        >mdi-delete</v-icon
                      >

                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left"></div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
    <AlertBox
      :width="modalwidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="{ selectedTest, category,message }"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import constants from "@/utils/constants.js";

export default {
  name: "UpcomingTests",
  props: ["category","tab","value"],
  data() {
    return {
      orderBy: {
        field: "alt_test_name",
        order: "ASC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      switch1: true,
      headers: [
        {
          text: "Test ID",
          class: "text-left",
          value: "id",
          hideSort: true,
        },,
        {
          text: "Test Name",
          class: "text-left",
          value: "alt_test_name",
          hideSort: true,
        },
        {
          text: "",
          type: "empty",
          hideSort: true,
          class: "text-center",
        },
        {
          text: "Start Date & Time",
          class: "text-center",
          value: "scheduled_start",
          hideSort: false,
        },
        {
          text: "End Date & Time",
          class: "text-center",
          value: "scheduled_end",
          hideSort: false,
        },
        {
          text: "Duration(mins)",
          class: "text-center",
          value: "duration",
          hideSort: true,
        },
        {
          text: "Scheduled by",
          value: "name",
          hideSort: true,
          class: "text-left",
        },
        {
          text: "",
          type: "empty",
          hideSort: true,
          class: "text-center",
        },
        {
          text: "",
          type: "empty",
          hideSort: true,
          class: "text-center",
        },
      ],
      items: [],
      status: false,
      cComponent: "components/coordinator/Tests/ScheduleTestPopup",
      ltComponent: "components/coordinator/Tests/LiveTrackingPopup",
      selectedTest: null,
      modalwidth: "1000px",
      message:''
    };
  },
  mounted() {
    this.OMR_PATTERN = constants.OMR_PATTERN;
    this.defaultData();
    if (this.category === "ONGOING" && !this.checkUserType(this.roleIds.ED)) {
      this.headers.push({
        text: "",
        type: "empty",
        hideSort: true,
        class: "text-center",
      });
    }
  },
  methods: {
    ...mapActions({
      getScheduleTestList: "testStore/getScheduleTestList",
      deleteScheduleTest: "testStore/deleteScheduleTest",
    }),
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.currentPage = crd.tabDetails[crd.selectedTab].page;
        this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
      }
      this.requestGetTestList();
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
      }
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getFormatedTime(date) {
      return moment(date).format("hh:mm A");
    },
    onClose(data) {
      this.status = data.status;
      if (data.realodTest) {
        this.requestGetTestList();
      }
      if (data.action === 'yes') {
        this.deleteScheduledTest(data.selectedTest)
      }
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
    requestGetTestList() {
      let reqData = {
        category: this.category,
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.$root.showLoader = true;
      this.getScheduleTestList(reqData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.$root.showLoader = false;
          this.items = response.list;
          this.totalPages = response.pagination.pageCount;
        })
        .catch((err) => {
          this.loading = false;
          this.$root.showLoader = false;
        });
    },
    ScheduleTestDialog(item) {
      item.test_name = item.alt_test_name;
      item.id = item.test_id;
      this.selectedTest = item;
      this.cComponent = "components/coordinator/Tests/ScheduleTestPopup";
      this.modalwidth = "1000px";
      this.status = true;
      this.$forceUpdate();
    },
    showLiveTrackingDialog(item) {
      item.test_name = item.alt_test_name;
      item.id = item.test_id;
      this.selectedTest = item;
      this.cComponent = this.ltComponent;
      this.modalwidth = "1200px";
      this.status = true;
      this.$forceUpdate();
    },
    deleteScheduledTest(test){
      let reqData = {
        test_schedule_id: test.schedule_id
      }
      this.$root.showLoader = true;

      this.deleteScheduleTest(reqData)
        .then((response)=>{
      this.$root.showLoader = false;
          this.$toasted.success(response.message);
          this.requestGetTestList()
        }).catch(err=>{
      this.$root.showLoader = false;

        })
    },
    deleteScheduleTestPopup(test){
      this.selectedTest = test;
      this.message = 'Are you sure you want to delete scheduled test?'
      this.cComponent = "components/coordinator/ConfirmationDialog";
      this.modalwidth = "380px";
      this.status = true;
      this.$forceUpdate();
    }
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  watch:{
    tab(val){
			if (val === this.value) {
				this.requestGetTestList();
			}
		}
  }
};
</script>
